export const HISTORY_CHART_FONT = 'ui-monospace';

export async function waitForHistoryChartFonts() {
  if (typeof document === 'undefined' || !document.fonts?.load) {
    return;
  }

  await Promise.all([
    document.fonts.load('700 10px ui-monospace'),
    document.fonts.load('700 11px ui-monospace'),
    document.fonts.load('700 12px ui-monospace'),
  ]).catch(() => {});

  await document.fonts.ready;
}
